import React, { useContext, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography, Link, IconButton, Menu, MenuItem, Divider, Chip, Grid } from '@material-ui/core'
import { PageContext } from '../Context/PageProvider'
import Moment from 'react-moment';
import AlertModal from '../Components/AlertModal'

import { COLORS } from '../Stylesheet/theme'

import AnnouncementIcon from '@material-ui/icons/Announcement';
import SmsIcon from '@material-ui/icons/Sms'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import LaunchIcon from '@material-ui/icons/Launch'
import MessageModal from '../Components/MessageModal'
import MessageIcon from './MessageIcon'



const ITEM_HEIGHT = 48;


function CustomTableRow({ t, row }) {
    const classes = useStyles()

    const context = useContext(PageContext)
    const api = context.api

    const [openModal, setOpenModal] = useState(false) // New Message || Edit Message 
    const [openMenu, setOpenMenu] = useState(false) // More Action Menu
    const [showAlertModal, setShowAlertModal] = useState(null) //Confirm Modal


    const handleEdit = () => {
        setOpenMenu(false)
        setOpenModal(true)
    }

    const handleConfirm = () => {
        setOpenMenu(false)
        setShowAlertModal(true)
    }

    const handleDelete = async (id) => {
        try {
            await api.messageService.deleteMessage(id)
            await context.loadMessages()
            setShowAlertModal(null)

        } catch (error) {
            console.log("handleDelete Error: ", error)
        }
    }

    const handleClick = (event) => {
        setOpenMenu(event.currentTarget)
    }

    const handleClose = () => {
        setOpenMenu(null)
    }

    return (
        <>
            <Box component="div" className={classes.root}>
                <Box component="div" className={classes.iconColumn}>
                    {
                        row.messageType && row.messageType === "message" ? <MessageIcon icon={<SmsIcon style={{ color: '#fff' }} />} backgroundColor={COLORS.PRIMARY} /> :
                            row.messageType === "alert" && <MessageIcon icon={<AnnouncementIcon style={{ color: '#fff' }} />} backgroundColor={COLORS.DESTRUCTIVE} />
                    }
                </Box>
                <Box component="div" className={classes.contentColumn}>
                    <Typography variant={'h2'} className={classes.title}>{row.title}</Typography>
                    <Typography variant={'body1'} className={classes.body}>{row.body}</Typography>
                    {
                        row.link && <Link className={classes.link} href={row.link} target="_blank">
                            <LaunchIcon className={classes.linkIcon} /> {row.link}
                        </Link>
                    }
                    <Moment element={Typography} className={classes.date} format={'DD.MM.yyyy HH:mm'} date={row.date} />
                </Box>
                <Box component="div">
                    <Grid container justify="flex-end">
                        {row.target.toString().toLowerCase() === "customer" ? (<Chip label={t('guest').toUpperCase()} color={'primary'} />)
                            : (<Chip label={row.target.toString().toUpperCase()} color={'primary'} />)}
                    </Grid>
                    <Grid container justify="flex-end">
                        <Chip label={row.language.toString().toUpperCase()} color={'default'} />
                    </Grid>
                    {row.pushNotification && <Grid container justify="flex-end">
                        <Chip label={t('push_notification')} color={'secondary'} />
                    </Grid>}
                </Box>
                <Box component="div" className={classes.actionColumn}>
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={openMenu}
                        keepMounted
                        open={openMenu}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: '20ch',
                            },
                        }}
                    >
                        <MenuItem onClick={() => handleEdit()}> {t('edit')} </MenuItem>
                        <MenuItem onClick={() => handleConfirm(row._id)}> {t('delete')} </MenuItem>
                    </Menu>
                </Box>
            </Box>
            <Divider />
            {
                openModal && <MessageModal item={row} open={true} handleClose={() => setOpenModal(false)} />
            }
            {
                showAlertModal &&
                <AlertModal
                    open={true}
                    title={t('delete_message')}
                    message={t('do_you_confirm_delete_this_message')}
                    submitButtonTitle={t('yes').toUpperCase()}
                    cancelButtonTitle={t('no').toUpperCase()}
                    onSubmit={() => {
                        handleDelete(row._id)
                    }}
                    onCancel={() => setShowAlertModal(null)} />
            }
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        padding: theme.padding.small
    },
    iconColumn: {
        paddingRight: theme.padding.small
    },
    contentColumn: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
    title: {
        marginBottom: theme.margin.extraSmall
    },
    body: {
        marginBottom: theme.margin.small
    },
    link: {
        textDecoration: 'none',
        alignItems: 'center',
        display: 'flex',
        marginBottom: theme.margin.small
    },
    linkIcon: {
        marginRight: theme.margin.extraSmall
    },
    date: {
        fontSize: 12,
        lineHeight: "16px",
        color: theme.palette.primary.dark_65,
    },
    divider: {
        backgroundColor: theme.palette.primary.dark10,
        height: 1,
        width: '100%'
    }

}))

export default withTranslation()(withRouter(CustomTableRow))